import React, { useRef, useCallback, useContext, useMemo } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useReactToPrint } from 'react-to-print';
import { salesService } from '../../services/sales.service';
import { Grid } from '@mui/material';
import GeneralModal from '../../helpers/GeneralModal';
import { createModal } from 'react-modal-promise';
import LogicContext from '../../Context/LogicContext';
import { ImAttachment } from 'react-icons/im';
import { FaFilePdf } from 'react-icons/fa';
import { MdDelete, MdEdit } from 'react-icons/md';
import { IoPrintSharp } from 'react-icons/io5';
import { toLowercaseKeys } from '../../helpers/toLowerCaseKeys';
import SalesReturnScroll from './SalesReturnScroll';
import SalesOrderReturnOverview from './SalesOrderReturnOverview';
import { Dropdown } from 'react-bootstrap';
import { SetSalesOrderReturnAtom, GetSalesOrderReturnAtom } from '../../store/salesOrderReturnAtom';



const SalesOrderReturnDetailsPage = () => {

  const myPromiseModal = createModal(GeneralModal);
      const setSalesReturnAtom = SetSalesOrderReturnAtom();
      const salesReturnAtom = GetSalesOrderReturnAtom();
  
 
  const logicContext = useContext(LogicContext);
  const { showToast } = useMemo(() => logicContext, [logicContext]); // Memoize context to avoid re-renders
  const { id } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [salesData, setSalesData] = useState({ so_return_main: {}, so_return_detail: [], so_return_image: [], return_action :[]});
  const url = pathname.split('/');
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const mountRef = useRef(false);
  const printableRef = useRef();


  // Fetch sales order details with abortable request
  useEffect(() => {

    mountRef.current = true;
    reloadSalesOrder();
 
    return () => {
      mountRef.current = false;
  
    };
  }, [id]);


// Inside your component
const reloadSalesOrder = useCallback(async () => {
  salesService
    .salesOrderReturnDetails(id)
    .then(response => {
      const serverData = toLowercaseKeys(response.data);

      if (mountRef.current && serverData.so_return_main !== undefined) {
        setSalesData({
          so_return_detail: serverData.so_return_detail || [],
          so_return_main: serverData?.so_return_main[0] || {},
          so_return_image: serverData?.so_return_image || [], // Fixed typo: was 'serverData'
          return_action: serverData?.return_action || [],
        });
      }
    })
   
    .catch(err => {
      // Handle error (e.g., set error state)
    });
}, [id, mountRef, setSalesData]);
  


 const getreturnedOrderListApi = useCallback(async () => {
        try {
          const response = await salesService.getSalesOrderReturnList();
          const serverData =  toLowercaseKeys(response.data);
            setSalesReturnAtom(serverData);
          
        } catch (err) {
         console.log("Error ", err);
        }
      }, []);
    


//   const reloadSalesOrderDataData = async () => {
//     setSalesData({});
//     salesService
//       .salesOrderDetails(id)
//       .then(response => {
//         const serverData = toLowercaseKeys(response.data);
//         if (mountRef.current && serverData !== undefined) {
//           if (serverData) {
//             setSalesData(serverData);
//             setSalesOrderListData(prev => {
//               const newList = prev['Sales_Order_Info'].map(salesOrder => {
//                 return salesOrder?.sales_order_ref_no === serverData.sales_order_ref_no ? response.data : salesOrder;
//               });
//               return { ...prev, sales_order_info: newList };
//             });
//           }
//         }
//       })
//       .catch(err => {});
//   };

  const viewDetails = useCallback(
    id => {
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
    },
    [currModuleId, currModuleName, currUserMenu, navigate]
  );



  const handlePrint = useReactToPrint({
    content: () => printableRef.current,
    documentTitle: `Sales Order - ${salesData?.sales_Order_No || salesData?.sales_order_ref_no || 'Details'}`,
    removeAfterPrint: true,
    bodyClass: 'print-body', // Apply print-specific styles
  });


  const deleteReturnOrder = useCallback(() => {
   window.alert("Currently not available!");
  }, []);



  const viewSalesDetails = useCallback(
    salesOrderId => {
      navigate(`/${currModuleId}/${currModuleName}/sales/details/${salesOrderId}`);
    },
    [currModuleId, currModuleName, navigate]
  );



    const singleActionPerform = useCallback(
      async action => {
        const result = await myPromiseModal({
          title: 'Confirm your action!',
          body: `This sales status will be ${action.action_name}?`,
          showInput: true,
          placeHolder: 'Enter message',
        });

 
  
        if (result.decision === true) {
          const formData = { return_ref_no:id, return_remark_grocedy:result?.message, option: action.action_option};
          salesService .salesOrderReturnAction(formData)
            .then(res => {
                if (res?.data !== undefined) {
                  const cleanResponse = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
                  const { message_id, message_text } = cleanResponse;

                  if (message_id == 1) {
                    logicContext.showToast(message_text, 'success');
                   reloadSalesOrder();
                   getreturnedOrderListApi();
                  }
                }
            })
            .catch(err => {
              showToast('Error', 'error');
            });
        }
      },
      [myPromiseModal, id,reloadSalesOrder, showToast]
    );


    const updateSalesOrderItems =  async(formData) => {
       const res = await salesService.updateSalesReturnItems(formData);
        if (res?.data !== undefined) {
          const cleanResponse = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
          const { message_id, message_text } = cleanResponse;

          if (message_id == 1) {
            logicContext.showToast(message_text, 'success');
            reloadSalesOrder();
          }
        }
    }


  return (
    <section className="mt-2">
      <style>{`
        @media print {
          body.print-body {
            margin: 0;
            padding: 15px;
            font-size: 12px;
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #333;
          }
          .print-header { 
            text-align: center; 
            margin-bottom: 30px; 
            border-bottom: 2px solid #007bff;
            padding-bottom: 20px;
          }
          .print-header h1 {
            color: #007bff;
            margin: 0;
            font-size: 28px;
          }
          button, .btn, .dropdown, .MuiTab-root, .MuiTabList-root {
            display: none !important;
          }
          .MuiTabPanel-root[hidden] {
            display: none !important;
          }
        }
      `}</style>
      <div className="pb-3"></div>

      <section className="w-full">
        <div className="flex flex-row items-center justify-end">
          {}
          {salesData.return_action?.length > 0 && (
            <Dropdown className="mr-3">
              <Dropdown.Toggle className="text-sm text-white bg-[#476EF8]" id="dropdown-basic">
                ACTION
              </Dropdown.Toggle>
              <Dropdown.Menu className="mt-1 shadow-xl border-[1px] border-gray-200 rounded-md bg-white">
                {salesData.return_action?.map((option, i) => (
                  <Dropdown.Item className="border-1 active:bg-gray-200" key={i} onClick={() => singleActionPerform(option)}>
                    <div className="text-sm text-gray-600 py-[2px] hover:bg-100">{option?.action_name}</div>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          )}
          <div className="flex flex-row items-center space-x-1">
            {/* <div className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
              <ImAttachment className="h-[20px] w-[20px] flex-shrink-0 text-gray-600" />
            </div>
            <div onClick={handlePrint} className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
              <FaFilePdf className="h-[20px] w-[20px] flex-shrink-0 text-gray-600" />
            </div> */}
            <div onClick={handlePrint} className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
              <IoPrintSharp className="h-[23px] w-[23px] flex-shrink-0 text-gray-600" />
            </div>
            {/* <div onClick={editSalesOrder} className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
              <MdEdit className="h-[23px] w-[23px] flex-shrink-0 text-gray-600" />
            </div> */}
            {/* <div onClick={deleteReturnOrder} className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
              <MdDelete className="h-[23px] w-[23px] flex-shrink-0 text-gray-600" />
            </div> */}
          </div>
        </div>

        <section className="mt-4 lg:flex space-x-1">
          <div className="lg:w-[210px]">
            <SalesReturnScroll viewDetails={viewDetails} />
          </div>
          <div className="w-full overflow-x-hidden mt-4 lg:mt-0 lg:pl-4" ref={printableRef}>
            <div className="print-header no-print">
              <h4>Sales Order Return Details</h4>
              {/* <p>Return Order Reference: {salesData.so_return_main?.return_ref_no || 'N/A'}</p> */}
            </div>

            <SalesOrderReturnOverview
              id={salesData?.so_return_main?.return_ref_no}
              imageList={salesData.so_return_image}
              salesData={salesData.so_return_main}
              tableData={salesData.so_return_detail}
              viewSalesDetails={viewSalesDetails}
              updateSalesOrderItems={updateSalesOrderItems}
            />
          </div>
        </section>
      </section>
    </section>
  );
};

export default SalesOrderReturnDetailsPage;
